export enum DiggerPlanEnum {
  preExisting = 1,
  lite = 2,
  standard = 3,
  pro = 4,
  enterprise = 5,
}
